import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons'
import { Select } from '@mantine/core'
import { useEffect, useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useProductListFilters } from './useProductListFilters'

export function FilterSorter() {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  const [sort, setSort] = useState('')

  const { filters, setFilter } = useProductListFilters()

  const options = [
    {
      label: t('sort_by_newest'),
      value: 'created_at__asc',
    },
    {
      label: t('sort_by_price_asc'),
      value: 'price_cents__asc',
    },
    {
      label: t('sort_by_price_desc'),
      value: 'price_cents__desc',
    },
    {
      label: t('sort_by_name_asc'),
      value: 'title__asc',
    },
    {
      label: t('sort_by_name_desc'),
      value: 'title__desc',
    },
  ]

  const handleChangeSort = (value: string | null) => {
    if (!value) {
      return
    }

    setSort(value)

    const parts = value.split('__')

    if (parts.length > 1) {
      setFilter('sort', parts[0])
      setFilter('order', parts[1])
    }
  }

  useEffect(() => {
    if (filters.order && filters.sort) {
      setSort(`${filters.sort}__${filters.order}`)
    }
  }, [filters.order, filters.sort])

  return (
    <Select
      size='sm'
      w={170}
      data={options}
      value={sort}
      leftSection={<Icon icon={faArrowUpArrowDown} size='xs' />}
      onChange={handleChangeSort}
    />
  )
}
